import React from "react";

import RecipeCard from "./RecipeCard";

const RecipeList = ({ title, recipes, onSelectRecipe }) => {
  const hasRecipes = recipes.length > 0;

  return (
    <div>
      {title && <h1 className="mb-6 text-2xl font-bold text-primary">{title}</h1>}

      {hasRecipes ? (
        <div className="grid grid-cols-1 grid-rows-1 justify-items-center gap-6 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
          {recipes.map((recipe) => (
            <RecipeCard
              key={recipe.id}
              recipe={recipe}
              onClick={() => onSelectRecipe(recipe.id)}
            />
          ))}
        </div>
      ) : (
        <p className="text-center text-lg text-slate-500">No recipes found.</p>
      )}
    </div>
  );
};

RecipeList.defaultProps = {
  title: "",
};

export default RecipeList;

